import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Table, IconButton, Icon, Button, Row, Col, Checkbox, Uploader } from 'rsuite'
import {
  initialNewData,
  getExpandedId,
  getNewDataEdit,
} from '../incomeRecordWidget/IncomeRecordUtils'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'

import ConfirmWidget from '../confirm/ConfirmWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import { cloneDeep, forEach } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { hasMinValidator, isValidators } from '../../utils/ValidatorUtils'
import { budgetFormat } from '../../utils/formatterUtil'
import { v4 as uuidv4 } from 'uuid'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function PaymentRecordAdvanceTable({
  schema,
  loading,
  isEnableEdit,
  onChangeTableData = () => {},
  register,
  errors,
  control,
  setError,
  setValue,
  getValues,
  clearErrors,
  isViewMode,
  objectDisabled,
  isAddDisabled,
  ...props
}) {
  const { isReceiveAnnuity } = props
  // const { register, handleSubmit, errors, control, setError, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showControlEdit, setShowControlEdit] = useState(true)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values || [])
    register('table', schema.values || [])
    setValue('table', schema.values || [])
    // setValue('borrowDetails', schema.values?.filter((e) => !e.isRowTotal) || [])
  }, [schema.values])

  const handleOpenEditRow = (rowData) => {
    console.log('row data => ', rowData)
    tableData.map((row) => {
      if (row.id == rowData.id) {
        const nextData = getNewDataEdit(tableData, row)
        setTableData(nextData)
      }
    })
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)
    // console.log('ggggggg ', datas)
    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas && datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        listId: '',
        list: '',
        subProjectCode: '',
        cashAccountOnHand: 'รวม (บาท)',
        amount: 0,
        withholding: 0,
        receivedAmount: 0,
        isRowTotal: true,
      }
    }

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    setTableData(datas)

    setValue('table', datas)
  }
  // setShowControlEdit(!showControlEdit)

  const handleOnClickAddNewData = () => {
    // setTableData()
    let datas = cloneDeep(tableData)

    var lasted = datas[datas.length - 1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        listId: '',
        list: '',
        subProjectCode: '',
        cashAccountOnHand: 'รวม (บาท)',
        amount: 0,
        withholding: 0,
        receivedAmount: 0,
        isRowTotal: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      listId: '',
      list: '',
      subProjectCode: '',
      cashAccountOnHand: '',
      amount: 0,
      withholding: 0,
      receivedAmount: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    setTableData(datas)

    setValue('table', datas)
  }

  const onChangeList = (index, value) => {
    let datas = cloneDeep(tableData)

    datas[index].listId = value

    if (value != '3') {
      datas[index].subProjectCode = ''
    }

    setTableData(datas)

    setValue('table', datas)
    // setValue(
    //   'borrowDetails',
    //   datas?.filter((e) => !e.isRowTotal)
    // )
  }

  const onChangeTableValue = (index, value, key) => {
    let datas = cloneDeep(tableData)

    datas[index].amount = value || 0

    setTableData(datas)
    setValue('table', datas)
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.amount && !cur.isRowTotal) {
        return pre + cur.amount
      }
      return pre
    }, 0)
  }

  return (
    <>
      {/* <ErrorMessage error={errors['borrowDetails']} />
      <Controller
        name={'borrowDetails'}
        control={control}
        defaultValue={tableData}
        rules={{ required: `กรุณาเพิ่มรายการ` }}
      /> */}

      <div className="table-affix-header">
        <Table
          wordWrap
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          affixHeader
        >
          <Column width={120} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return ''
                }
                return index + 1
              }}
            </Cell>
          </Column>

          <Column minWidth={200} flexGrow={1}>
            <HeaderCell style={styleHeaderCell}>จ่ายให้กิจกรรม</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status != 'EDIT') {
                  return rowData.isRowTotal ? (
                    <b>{rowData.list}</b>
                  ) : (
                    `${rowData.listId ? rowData.listId + ' : ' : ''}${rowData.list || ''}`
                  )
                }

                return (
                  <EditSelectCell
                    id={`${schema.list.name}_${rowData.id}`}
                    // id={`table[${index}].${schema.list.name}`}
                    rowData={rowData}
                    rowSchema={schema.list}
                    dataKey={schema.list.name}
                    defaultValue={rowData.listId}
                    register={register}
                    control={control}
                    errors={errors}
                    disabled={!isEnableEdit || isReceiveAnnuity}
                    searchable
                    // onChange={onChangeList}
                    onChangeCell={(value) => {
                      onChangeList(index, value)
                    }}
                    index={index}
                  />
                )
              }}
            </Cell>
          </Column>

          {/* <Column width={180}>
          <HeaderCell style={styleHeaderCell}>vvv</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isRowTotal) {
                return (
                  <div style={{ width: '100%', textAlign: 'right' }}>
                    <b>{rowData.cashAccountOnHand}</b>
                  </div>
                )
              } else {
                if (!rowData.isDeletable) {
                  var data = schema.subProjectCode?.options?.find(
                    (e) => e.value == rowData.subProjectCode
                  )
                  // console.log('data : ', data)
                  return data?.label //rowData.subProjectCode
                }
                if (rowData.listId == '3') {
                  return (
                    <EditSelectCell
                      // id={`${schema.subProjectCode.name}_${rowData.id || rowData.makeId}`}
                      id={`table[${index}].${schema.subProjectCode.name}`}
                      rowData={rowData}
                      rowSchema={schema.subProjectCode}
                      dataKey={schema.subProjectCode.name}
                      register={register}
                      control={control}
                      errors={errors}
                      disabled={!isEnableEdit || isReceiveAnnuity}
                      value={rowData.subProjectCode}
                      index={index}
                    />
                  )
                }
                return ''
              }
            }}
          </Cell>
        </Column> */}

          <Column width={180} align="right">
            <HeaderCell style={styleHeaderCell}>จำนวนเงิน</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span className={'cost-total-summary'}>
                      {`${budgetFormat(getTotalSummary(tableData))}`}
                    </span>
                  )
                }

                return (
                  <EditNumberCell
                    id={`${schema.amount.name}_${rowData.id}`}
                    // id={`table[${index}].${schema.amount.name}`}
                    rowData={rowData}
                    dataKey={schema.amount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    // disabled={!isEnableEdit || isReceiveAnnuity}
                    disabled={objectDisabled}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) => {
                      onChangeTableValue(index, value)
                    }}
                    allowNegative={!hasMinValidator(schema.amount.validators)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          {!isViewMode && (
            <Column width={200} align="center" fixed="right">
              <HeaderCell style={styleHeaderCell}>จัดการรายการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  // console.log('row ', rowData.isRowTotal)
                  console.log('objectDisabled ', objectDisabled)
                  if (index == tableData.length - 1) {
                    if (objectDisabled) {
                      return ''
                    }
                    return (
                      <>
                        {!isReceiveAnnuity && (
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                            onClick={handleOnClickAddNewData}
                            disabled={
                              tableData.filter((e) => !e.isRowTotal).length > 0 || isAddDisabled
                            }
                            style={{ marginLeft: 5 }}
                          >
                            {'เพิ่มรายการ'}
                          </IconButton>
                        )}
                      </>
                    )
                  }

                  if (rowData.isRowTotal) {
                    return ''
                  }

                  return (
                    <>
                      {rowData.id?.indexOf('addNew') == -1 && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleOpenEditRow(rowData)}
                          // disabled={!isEnableEdit}
                          size="sm"
                        >
                          {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                        </IconButton>
                      )}

                      {!isReceiveAnnuity && !objectDisabled && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => {
                            onDeleteRow(rowData)
                          }}
                          size="sm"
                          style={{ marginLeft: 5 }}
                        >
                          ลบ
                        </IconButton>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        // detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />

      {/* <>
        <div>
          <br />
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Button color="red" appearance="link" disabled={isReceiveAnnuity}>
                <Icon icon="trash" size="lg" /> ลบเอกสาร
              </Button>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <Button color="blue" appearance="link">
                <Icon icon="search" size="lg" /> ใบสำคัญจ่าย
              </Button>
              <CancelButton>ยกเลิก</CancelButton>
              <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
            </Col>
          </Row>
        </div>
      </> */}
      {/* )} */}
    </>
  )
}
